// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1XiVr","itemTitle":"ClientEmergencyInfo_itemTitle__3Gh43","itemText":"ClientEmergencyInfo_itemText__3OObG"};